import { render, staticRenderFns } from "./VGalleryInspectionsPublic.vue?vue&type=template&id=45e934a7"
import script from "./VGalleryInspectionsPublic.vue?vue&type=script&lang=js"
export * from "./VGalleryInspectionsPublic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports